import * as React from "react";

export const AssetIcon = (props: { className?: string; color: string }): JSX.Element => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
            d="M13 8.875C13 8.60978 13.1054 8.35543 13.2929 8.16789C13.4804 7.98036 13.7348 7.875 14 7.875H20C20.2652 7.875 20.5196 7.98036 20.7071 8.16789C20.8946 8.35543 21 8.60978 21 8.875V18.875C21 19.1402 20.8946 19.3946 20.7071 19.5821C20.5196 19.7696 20.2652 19.875 20 19.875H14C13.7348 19.875 13.4804 19.7696 13.2929 19.5821C13.1054 19.3946 13 19.1402 13 18.875V8.875Z"
            stroke={props.color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M18 7.875V4.875C18 4.60978 17.8946 4.35543 17.7071 4.16789C17.5196 3.98036 17.2652 3.875 17 3.875H4C3.73478 3.875 3.48043 3.98036 3.29289 4.16789C3.10536 4.35543 3 4.60978 3 4.875V16.875C3 17.1402 3.10536 17.3946 3.29289 17.5821C3.48043 17.7696 3.73478 17.875 4 17.875H13"
            stroke={props.color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10 18.375V19.875"
            stroke={props.color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M3.5 15.375L12.5 15.375"
            stroke={props.color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M16 9.875H18" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9 20.125H11" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);
